import { render, staticRenderFns } from "./TelefoneFixoField.vue?vue&type=template&id=75349d81&scoped=true&"
import script from "./TelefoneFixoField.vue?vue&type=script&lang=js&"
export * from "./TelefoneFixoField.vue?vue&type=script&lang=js&"
import style0 from "./TelefoneFixoField.vue?vue&type=style&index=0&id=75349d81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75349d81",
  null
  
)

export default component.exports